// extracted by mini-css-extract-plugin
module.exports = {"content":"Fitting_content__1KyuU","submitBtn":"Fitting_submitBtn__zX1fR"};